__turbopack_context__.v({
  "wrapper": "BackButton-module-scss-module__qX7Q8W__wrapper",
});
